import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { MedLinkComponent } from "./med-link.component";

@NgModule({
  declarations: [
    MedLinkComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    MedLinkComponent,
  ],
})
export class MedLinkModule { }
